import Spinner from "react-bootstrap/Spinner";
import { useSelector } from "react-redux";
import "./index.scss";
import Modal from 'react-bootstrap/Modal'
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { setAppColor } from "helper";
// import { setAppColor } from "helper";
export const LoadingSpinner = ({ className ,paymentLoadingText}) => {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);


  const loadingText = useSelector(
    (state) => state.configurationReducer.loadingText
  );

  // const layoutSettings = useSelector((state)=> state?.loggedInUserInfo?.userAuthInfo?.organisationInfo?.layout_setting)
  // setAppColor(layoutSettings);
  // const colorLoadDelay = setTimeout(()=>{
  //   setAppColor(layoutSettings);
  //   clearTimeout(colorLoadDelay);
  // },100)
  


  return (
    <>
    <div className="loadingText d-flex justify-content-center">{loadingText || paymentLoadingText}</div>
    <Modal show={show} onHide={handleClose}
    backdrop="static"
    keyboard={false}
    centered
    animation={false}
    className="bg-modal-transparent modal-no-br modal-no-border"
  >
    <Modal.Body className="d-flex justify-content-center ">
      <div className="loader" />
    </Modal.Body>
  </Modal>
  </>
  );
};

LoadingSpinner.propTypes = {
  className: PropTypes.string,
  paymentLoadingText: PropTypes.string
};

export default LoadingSpinner;
